$(document).ready(initPage);

function initPage() {
  function checkScroll() {
    if($(window).scrollTop() > 0){
      $('body').addClass('is-scrolled');
    } else {
      $('body').removeClass('is-scrolled')
    }
  }

  checkScroll();
  $(window).scroll(function(){
    checkScroll();
  });

  $('.header-toggler').click(function() {
    $('.header').toggleClass('is-menu');
  });
}
